import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import SchoolIcon from "@mui/icons-material/School";
import QuizIcon from "@mui/icons-material/Quiz";
import HubIcon from "@mui/icons-material/Hub";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";

const features = [
  {
    icon: <DescriptionIcon sx={{ fontSize: 42 }} />,
    title: "Summarize Topics",
    desc: "Get concise AI-generated summaries for any uploaded course material.",
  },
  {
    icon: <SchoolIcon sx={{ fontSize: 42 }} />,
    title: "Learning Plan",
    desc: "Receive a structured learning plan based on your syllabus.",
  },
  {
    icon: <QuizIcon sx={{ fontSize: 42 }} />,
    title: "Sample Question Papers",
    desc: "Generate practice papers based on selected subjects and topics.",
  },
  {
    icon: <HubIcon sx={{ fontSize: 42 }} />,
    title: "Mermaid JS Flowcharts",
    desc: "Convert your code into clear, interactive Mermaid JS flowcharts.",
  },
  {
    icon: <QuestionAnswerIcon sx={{ fontSize: 42 }} />,
    title: "Query-Based Answers",
    desc: "Ask questions based on uploaded faculty material and get accurate answers.",
  },
];

export default function FeaturesSection() {
  return (
    <Box sx={{ textAlign: "center", py: 8, px: 3 }}>
      <Typography
        variant="h4"
        fontWeight={700}
        sx={{ mb: 5, color: "#0F172A" }}
      >
        Powerful AI Features
      </Typography>

      <Grid
        container
        spacing={4}
        justifyContent="center"
        sx={{ maxWidth: "1200px", margin: "0 auto" }}
      >
        {features.map((f, i) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={i}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Paper
              elevation={3}
              sx={{
                width: "100%",
                maxWidth: 340,
                p: 4,
                background: "#111827",
                color: "white",
                borderRadius: "16px",
                textAlign: "center",
                transition: "0.3s",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 12px 30px rgba(0,0,0,0.3)",
                },
              }}
            >
              <Box sx={{ mb: 2, color: "#60A5FA" }}>{f.icon}</Box>

              <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>
                {f.title}
              </Typography>

              <Typography variant="body2" sx={{ opacity: 0.85 }}>
                {f.desc}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
